// extracted by mini-css-extract-plugin
module.exports = {"dialog":"styles_dialog__29oV6","submitButton":"styles_submitButton__1qKdu","label":"styles_label__2InmG"};